module.exports = __webpack_public_path__ + "static/media/Surveillance.f3e2be34.jpg";